module.exports = __webpack_public_path__ + "static/img/service3.af5de0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service3.jpg
// module id = R742
// module chunks = 21